/**
 * English display strings for the WeTree Web UI.
 * Prefer i18next (`pets` namespace). This map remains for non-React call sites.
 */

import i18n from '@/i18n/i18n';

const PET_CATEGORY_KEYS = [
  'dog',
  'cat',
  'mammal',
  'equine',
  'bird',
  'aquatic',
  'reptile',
  'amphibian',
  'invertebrate',
  'exotic',
  'other'
] as const;

/** Pet category: API value → display label (current locale via i18n) */
export const petCategory: Record<string, string> = new Proxy(
  {},
  {
    get(_target, prop: string | symbol) {
      if (typeof prop !== 'string') return undefined;
      return i18n.t(`pets:${prop}`, { defaultValue: prop });
    },
    ownKeys() {
      return [...PET_CATEGORY_KEYS];
    },
    getOwnPropertyDescriptor(_target, prop) {
      if (typeof prop === 'string' && (PET_CATEGORY_KEYS as readonly string[]).includes(prop)) {
        return { enumerable: true, configurable: true };
      }
      return undefined;
    }
  }
);
